export default "__VITE_ASSET__d8a2a77b__"